var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoUnmute = function SvgVideoUnmute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "video_unmute_svg__st0",
    d: "m23.23 6.21-4.21 1.52v-1.7c0-.57-.46-1.03-1.03-1.03H1.02C.45 5-.01 5.46-.01 6.03v11.94c0 .57.46 1.03 1.03 1.03H18c.57 0 1.03-.46 1.03-1.03v-1.71l4.21 1.53c.37.13.77-.11.77-.47V6.68c-.01-.35-.41-.6-.78-.47zm-19.71 3.8c-.82 0-1.49-.67-1.49-1.49s.67-1.49 1.49-1.49 1.49.67 1.49 1.49-.67 1.49-1.49 1.49z"
  })));
};
export default SvgVideoUnmute;